import { Component, Input } from '@angular/core';
import { NonSystemUserAvatarComponent } from '@app/standalone-components/user-avatars/non-system-user-avatar/non-system-user-avatar.component';
import { SystemUserAvatarComponent } from '@app/standalone-components/user-avatars/system-user-avatar/system-user-avatar.component';

@Component({
    selector: 'fdx-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrl: './user-avatar.component.scss',
    standalone: true,
    imports: [
        NonSystemUserAvatarComponent,
        SystemUserAvatarComponent
    ]
})
export class UserAvatarComponent {
    @Input() hasNotifications: boolean = false;

    @Input() userLoaded: boolean;
    @Input() id: string | number;
    @Input() firstName: string;
    @Input() lastName: string;

    get isNonSystemUser(): boolean {
        return this.userLoaded && !this.id;
    }
}
